import { useMemo } from "react";
import { useAuth } from "../context/AuthContext";

export function useCallsApi() {
  const { apiFetch } = useAuth();

  return useMemo(
    () => ({
      getReport: (days = 30) => apiFetch(`/calls/report?days=${days}`),

      startTranscript: (callId) =>
        apiFetch(`/calls/${encodeURIComponent(callId)}/transcript/start`, { method: "POST" }),

      // Campos antes do arquivo: o multer só preenche req.body com o que vem antes.
      sendTranscriptChunk: (callId, { speaker, offset, blob, ext }) => {
        const form = new FormData();
        form.append("speaker", speaker);
        form.append("offset", String(offset));
        form.append("audio", blob, `${speaker}.${ext}`);
        return apiFetch(`/calls/${encodeURIComponent(callId)}/transcript/chunk`, {
          method: "POST",
          body: form,
        });
      },

      getTranscript: (callId) => apiFetch(`/calls/${encodeURIComponent(callId)}/transcript`),

      finishTranscript: (callId) =>
        apiFetch(`/calls/${encodeURIComponent(callId)}/transcript/finish`, { method: "POST" }),
    }),
    [apiFetch],
  );
}
